





































































































































































































































































import { Component, Watch } from 'vue-property-decorator'
import ViewBase from '@/util/ViewBase'
import { getCateList, getAccountList, accountDel } from '@/api/admin'
import AccountForm from './accountForm.vue'
import { post, get } from '@/fn/ajax'
import { Tooltip, Modal, message } from 'ant-design-vue'
import plupload from 'plupload'
// import sparkMd5 from 'spark-md5'
import ResourceUploadRule from './resourceUploadRule.vue'

// 默认封面图链接
const defaultCover: any = {
  model: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/model.png',
  image: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/panorama.png',
  video: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/video.png'
}

let accessid = ''
let host = ''
let policy = ''
let signature = ''
let callback = ''
let dir = ''
const accesskey = ''
let policyBase64 = ''
let callbackbody = ''
const fileName = ''
let key = ''
let expire = new Date().getTime()
let gObjectName = ''
let tmpName = ''
let resourceName = ''
let coverName = ''
let now = Date.parse(new Date().toString()) / 1000
let timestamp = Date.parse(new Date().toString()) / 1000

function send_request() {
  let xmlhttp = null
  if ((window as any).XMLHttpRequest) {
    xmlhttp = new XMLHttpRequest()
  } else if ((window as any).ActiveXObject) {
    xmlhttp = new ActiveXObject('Microsoft.XMLHTTP')
  }

  if (xmlhttp != null) {
    // serverUrl是 用户获取 '签名和Policy' 等信息的应用服务器的URL，请将下面的IP和Port配置为您自己的真实信息。
    // serverUrl = 'http://88.88.88.88:8888/aliyun-oss-appserver-php/php/get.php'
    const serverUrl = 'https://growlib-glp-u-resources.oss-cn-beijing.aliyuncs.com/'

    xmlhttp.open('GET', serverUrl, false)
    xmlhttp.send(null)
    return xmlhttp.responseText
  } else {
    alert('Your browser does not support XMLHTTP.')
  }
}

function get_signature() {
  // 可以判断当前expire是否超过了当前时间， 如果超过了当前时间， 就重新取一下，3s 作为缓冲。
  now = timestamp = Date.parse(new Date().toString()) / 1000
  if (expire < now + 3) {
    host = host
    policyBase64 = policyBase64
    accessid = accessid
    signature = signature
    expire = expire
    callbackbody = callback
    key = dir
    return true
  }
  return false
}

function random_string(len: any) {
  len = len || 32
  const chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
  const maxPos = chars.length
  let pwd = ''
  for (let i = 0; i < len; i++) {
    pwd += chars.charAt(Math.floor(Math.random() * maxPos))
  }
  return pwd
}

function get_suffix(name: any) {
  const pos = name.lastIndexOf('.')
  let suffix = ''
  if (pos != -1) {
    suffix = name.substring(pos)
  }
  return suffix
}

function calculate_object_name(name: any) {
  const suffix = get_suffix(name)
  const date = new Date()
  gObjectName = key + random_string(10) + date.getTime() + suffix
  return ''
}

function get_uploaded_object_name(name: any) {
  tmpName = gObjectName
  tmpName = tmpName.replace('${name}', name)
  return tmpName
}

function set_upload_param(up: any, name: any, ret: any, type: any) {
  if (ret == false) {
    ret = get_signature()
  }
  gObjectName = key + '${name}'
  const suffix = get_suffix(name)
  calculate_object_name(name)
  if (type == 'resource') {
    resourceName = gObjectName
  } else {
    coverName = gObjectName
  }
  const newMultipartParams = {
    key: gObjectName,
    policy: policyBase64,
    OSSAccessKeyId: accessid,
    success_action_status: '200', // 让服务端返回200,不然，默认会返回204
    // callback: callbackbody,
    signature
  }

  up.setOption({
    url: host,
    multipart_params: newMultipartParams
  })

  up.start()
}

declare var PhotoSphereViewer: any
@Component({
  components: {
    AccountForm,
    ResourceUploadRule
  }
})
export default class ResourceUpload extends ViewBase {
  lang: any = {}

  doc: any = null

  // 资源转换为url
  viewSrc: string = ''

  // 展示普通视频
  viewVideo: boolean = false

  // // 展示普通图片
  // viewImg: boolean = false

  // 展示全景视频
  viewScreenVideo = false

  // 展示全景图片
  viewScreenImg = false

  // 上传文件路径
  filePath: string = ''

  // 显示类型 1 全景 2 2d
  screen: any = 11

  // 上传文件类型文字
  fileType: string = ''

  // 全景播放器实例
  resourceViewer: any = null

  // 资源不符合标准提示
  resourceWarn: string = ''

  // 上传的资源是否符合要求
  isAcceptFile: boolean = true

  // 上传的封面是否符合要求
  allowCover: boolean = true

  // 上传封面不符合要求提示
  coverWarn: string = ''

  // 封面url
  coverSrc: string = ''

  // 封面图路径
  coverPath: string = ''

  form: any = null

  // 是否展示资源上传进度条
  resourceProgress: boolean = false

  // 上传资源进度百分比
  resourceProgressPercent: number = 0

  // 是否展示上传封面进度条
  coverProgress: boolean = false

  // 上传封面进度百分比
  coverProgressPercent: number = 0

  // 上传3D模型成功
  zipSuccess: boolean = false

  resourceFileUploaded: boolean = false

  // md5: any = null

  fileSize: any = null

  submiting: boolean = false

  // 是否上传过封面
  upLoadedCover: boolean = false

  title: string = ''

  point: string = ''

  desc: string = ''

  label: string = ''

  autoPrimary: any = []

  autoMiddle: any = []

  rid: string = ''

  resType: any = null
  // 已用云盘空间
  used: string = ''
  //  剩余云盘空间
  total: string = ''
  // 剩余云盘空间
  remain: string = ''

  // 提交按钮禁用
  btnDisable: boolean = false
  // 规则弹窗
  ruleConfirm: boolean = false
  // 封面图大小
  coverFileSize: any = null
  // 上一次上传的文件地址 用于删除无用资源
  lastResourceUrl: string = ''
  // 上一次上传的封面地址
  lastCoverUrl: string = ''
  // 展示远端资源
  showOriginResource: boolean = false
  // 展示远端封面
  showOriginCover: boolean = false
  // 已有封面图
  hasCover: boolean = false
  // 已存在资源
  currentResource: boolean = false
  get i18n() {
    const value = this.$t('login')
    return value as any
  }

  // resourceUploadClick() {
  //   this.$refs.uploadBtn.click()
  // }
  // coverUploadClick() {
  //   this.$refs.coverUploadBtn.click()
  // }
  // 全景图片
  initPanoramaImage() {
    const player: any = this.$refs.refPlayerImg
    const _this = this
    player.innerHTML = ' '
    _this.resourceViewer = new PhotoSphereViewer({
      container: player,
      panorama: _this.viewSrc,
      // loading_img: '/lib/photo/assets/photosphere-logo.gif',
      loading_load: true,
      time_anim: false,
      navbar: null
    })
  }
  // 全景视频
  initPanoramaVideo() {
    const _this = this
    const volume = false
    const videoPlayer: any = this.$refs.refVideoPlayer
    videoPlayer.innerHTML = ' '
    this.resourceViewer = new PhotoSphereViewer.Video({
      container: videoPlayer,
      video: [
        { source: _this.viewSrc, resolution: 'HD' },
        { source: _this.viewSrc, resolution: 'SD' }
      ],
      default_resolution: 'SD',
      muted: false,
      caption: 'openid.tiele',
      // loading_img: '/lib/photo/assets/photosphere-logo.gif',
      loading_load: true,
      navbar: ['playpause', 'volume']
    })
  }

  ruleChange(vals: any) {
    if (vals.length < 1) {
      this.btnDisable = true
    } else {
      this.btnDisable = false
    }
  }

  readRule() {
    this.ruleConfirm = true
  }

  cancelRule() {
    this.ruleConfirm = false
  }

  setViewType(fileText: string, createView: boolean = true) {
    if (this.resourceViewer != null) {
      if (this.resourceViewer.stop) {
        this.resourceViewer.stop()
      }
      this.resourceViewer.destroy()
      this.resourceViewer = null
    }
    if (fileText.indexOf('mp4') != -1 || (this.resType == 1 && fileText == '')) {
      if (!this.hasCover && !createView) {
        this.coverSrc = defaultCover.video
      }
      this.viewScreenImg = false
      this.zipSuccess = false
      if (this.screen == 21) {
        this.viewVideo = true
        this.viewScreenVideo = false
      } else {
        this.viewScreenVideo = true
        this.viewVideo = false
        this.$nextTick(() => {
          if (createView) {
            this.initPanoramaVideo()
          }
        })
      }
      return true
    } else if (
      fileText.indexOf('image') != -1 ||
      (this.resType == 4 && fileText == '')
    ) {
      if (!this.hasCover && !createView) {
        this.coverSrc = defaultCover.image
      }
      this.viewVideo = false
      this.viewScreenVideo = false
      this.zipSuccess = false
      this.viewScreenImg = true
      this.$nextTick(() => {
        if (createView) {
          this.initPanoramaImage()
        }
      })
      return true
    } else if (fileText.indexOf('zip') != -1 || (this.resType == 3 && fileText == '')) {
      if (!this.hasCover && !createView) {
        this.coverSrc = defaultCover.model
      }
      this.zipSuccess = true
      this.viewScreenImg = false
      this.viewScreenVideo = false
      this.viewVideo = false
      return true
    } else {
      return false
    }
  }
  screenChange() {
    this.setViewType(this.fileType)
  }

  // 上传资源
  getBigectURL(event: any) {
    const current = event.files[0]
    this.fileType = current.type
    this.filePath = current.name
    const fileReader = new FileReader()
    const file = current.getNative()
    fileReader.readAsDataURL(file)
    // const _this = this
    this.setViewType(current.type, false)
    // fileReader.onload = (e: any) => {

    // }
  }
  // 校验上传封面图
  checkCover(imageType: any) {
    if (
      imageType.indexOf('png') != -1 ||
      imageType.indexOf('jpg') != -1 ||
      imageType.indexOf('jpeg') != -1
    ) {
      return true
    } else {
      return false
    }
  }

  // 上传封面图

  getCoverURL(event: any) {
    const current = event.files[0]
    this.coverPath = current.name
    const fileReader = new FileReader()
    const file = current.getNative()
    fileReader.readAsDataURL(file)
    const _this = this
    fileReader.onload = (e: any) => {
      _this.coverSrc = e.currentTarget.result
      _this.allowCover = _this.checkCover(current.type)
    }
  }

  // 获取文件上传配置
  async setConfig() {
    const url = '/api/UserRes/getUploadPolicy'
    await get(url).then(res => {
      const data = res.data
      accessid = data.accessid
      host = data.host
      policy = data.policy
      policyBase64 = data.policy
      signature = data.signature
      expire = data.expire
      callback = data.callback
      dir = data.dir
      key = data.dir
    })
  }

  // 初始化资源上传插件
  initPlUploader() {
    const _this = this
    const uploader = new plupload.Uploader({
      runtimes: 'html5,flash,silverlight,html4',
      browse_button: 'selectfiles',
      // multi_selection: false,
      // container: document.getElementById('container'),
      // flash_swf_url : 'lib/plupload-2.1.2/js/Moxie.swf',
      // silverlight_xap_url : 'lib/plupload-2.1.2/js/Moxie.xap',
      url: 'http://oss.aliyuncs.com',
      drop_element: 'resource',
      multi_selection: false,

      filters: {
        mime_types: [
          // 只允许上传图片和zip文件
          { title: 'Image files', extensions: 'jpg,png,bmp,jpeg' },
          // { title: 'Zip files', extensions: 'zip' },
          { title: 'Video files', extensions: 'mp4' }
        ],
        max_file_size: _this.remain, // 最大只能上传10mb的文件
        prevent_duplicates: true // 不允许选取重复文件
      },

      init: {
        PostInit: () => {},

        FilesAdded: (up: any, files: any) => {
          if (files.length > 1) {
            message.warn(_this.lang.muchData)
            return
          }
          _this.isAcceptFile = true
          up.files = files
          // const spark = new sparkMd5.ArrayBuffer()
          // let native = null
          // const fr = new FileReader()
          // 转换为filereader，否则和服务端生成的md5不同
          // fr.readAsArrayBuffer(files[0].getNative())
          // fr.onload = (e: any) => {
          //   native = e.target.result
          //   spark.append(native)
          //   _this.md5 = spark.end()
          //   _this.resourceProgress = true
          //   _this.resourceFileUploaded = false
          // }
          _this.resourceProgress = true
          _this.resourceFileUploaded = false
          const size: any = files[0].size / 1024
          _this.fileSize = parseInt(size, 10)
          _this.getBigectURL(up)
          set_upload_param(uploader, files[0].name, false, 'resource')
          _this.showOriginResource = false
          return false
        },

        BeforeUpload: (up: any, file: any) => {},

        UploadProgress: (up: any, file: any) => {
          _this.resourceProgressPercent = file.percent
          if (file.percent == 100) {
            _this.resourceProgress = false
            _this.resourceProgressPercent = 0
          }
        },

        FileUploaded(up: any, file: any, info: any) {
          if (info.status == 200) {
            // console.log(_this.lastResourceUrl)
            _this.isAcceptFile = true
            _this.resourceFileUploaded = true
            if (_this.lastResourceUrl) {
              const data = _this.setDeletePostData('resource', false)
              _this.deleteResource('resource', data)
            }
            if (resourceName != '') {
              _this.lastResourceUrl = host + '/' + resourceName
            }
            _this.currentResource = true
            _this.viewSrc = host + '/' + resourceName
            _this.isAcceptFile = _this.setViewType(_this.fileType)
          } else if (info.status == 203) {
            _this.isAcceptFile = false
            _this.resourceWarn = info.response
          } else {
            _this.isAcceptFile = false
            _this.resourceWarn = info.response
          }
        },

        Error(up: any, err: any) {
          _this.isAcceptFile = false
          _this.uploadError(err)
        }
      }
    })
    uploader.init()
  }

  setPhase(ids: any) {
    if (ids) {
      const subjectIds = ids.split(',')
      subjectIds.forEach((element: any) => {
        if (element < 10) {
          this.autoPrimary.push(element)
        } else {
          this.autoMiddle.push(element)
        }
      })
    }
  }

  getCloudSpace(refresh: boolean = false) {
    post('/api/UserRes/schoolCloudDisk').then(res => {
      if (res) {
        const data: any = res.data
        this.used = data.used
        this.total = data.total
        this.remain = data.remain
        if (refresh) {
          this.initPlUploader()
          this.initCoverUploader()
        }
      }
    })
  }

  uploadError(err: any) {
    if (err.code == -600) {
      this.resourceWarn = this.lang.outsizeData
    } else if (err.code == -601) {
      this.resourceWarn = this.lang.wrongData
    } else if (err.code == -602) {
      this.resourceWarn = this.lang.uploadAlready
    } else {
      this.resourceWarn = err.response
    }
  }

  // 加载已存在的资源
  async fetch() {
    const params = {
      rid: this.rid + ''
    }
    this.submiting = true
    try {
      const res = await post('/api/UserRes/item', params)
      if (res && res.data) {
        const data = res.data.item
        this.title = data.title
        this.desc = data.description
        this.point = data.knowledge_point
        this.label = data.key_word
        this.fileSize = data.file_size
        if (data.cover && data.cover.length) {
          this.coverSrc = data.cover
          this.hasCover = true
          this.upLoadedCover = true
          this.lastCoverUrl = data.cover
          this.coverFileSize = data.cover_file_size
        }
        this.viewSrc = data.file_url
        // this.md5 = data.file_md5
        if (data.res_type == 1 && data.type == 'video') {
          this.screen = data.file_type
        }
        this.form.setFieldsValue({
          name: data.title,
          desc: data.description,
          point: data.knowledge_point,
          label: data.key_word
        })
        this.currentResource = true
        this.lastResourceUrl = data.file_url
        this.resourceFileUploaded = true
        this.resType = data.res_type
        this.setPhase(data.subject_ids + '')
        this.setViewType('')
        this.showOriginResource = true
        this.showOriginCover = true
        this.submiting = false
      }
    } catch (ex) {
      this.handleError(ex)
    }
  }

  backList() {
    const data = this.setDeletePostData('resource', true)
    this.deleteResource('resource', data)
    const coverData = this.setDeletePostData('cover', true)
    this.deleteResource('cover', coverData)
    this.$router.push({
      name: 'resourceList',
      params: {}
    })
  }

  // 初始化封面上传插件
  initCoverUploader() {
    const _this = this
    const uploader = new plupload.Uploader({
      runtimes: 'html5,flash,silverlight,html4',
      browse_button: 'selectCover',
      // multi_selection: false,
      // container: document.getElementById('container'),
      // flash_swf_url : 'lib/plupload-2.1.2/js/Moxie.swf',
      // silverlight_xap_url : 'lib/plupload-2.1.2/js/Moxie.xap',
      url: 'http://oss.aliyuncs.com',
      drop_element: 'cover',
      multi_selection: false,

      filters: {
        mime_types: [
          // 只允许上传图片文件
          { title: 'Image files', extensions: 'jpg,png,bmp,jpeg' }
        ],
        max_file_size: _this.remain, // 最大只能上传10mb的文件
        prevent_duplicates: true // 不允许选取重复文件
      },

      init: {
        PostInit: () => {},
        FilesAdded: (up: any, files: any) => {
          if (files.length > 1) {
            message.warn(_this.lang.muchData)
            return
          }
          _this.allowCover = true
          const size: any = files[0].size / 1024
          _this.coverFileSize = parseInt(size, 10)
          up.files = files
          _this.getCoverURL(up)
          _this.coverProgress = true
          set_upload_param(uploader, files[0].name, false, 'cover')
          _this.showOriginCover = false
          return false
        },

        BeforeUpload: (up: any, file: any) => {},

        UploadProgress: (up: any, file: any) => {
          _this.coverProgressPercent = file.percent
          if (file.percent == 100) {
            _this.coverProgress = false
            _this.coverProgressPercent = 0
          }
        },

        FileUploaded(up: any, file: any, info: any) {
          if (info.status == 200) {
            // console.log(_this.lastCoverUrl)
            _this.allowCover = true
            if (_this.lastCoverUrl) {
              const data = _this.setDeletePostData('cover', false)
              _this.deleteResource('cover', data)
            }
            if (coverName) {
              _this.lastCoverUrl = host + '/' + coverName
              _this.coverSrc = host + '/' + coverName
            }
            _this.upLoadedCover = true
          } else if (info.status == 203) {
            _this.allowCover = false
            _this.coverWarn = info.response
          } else {
            _this.allowCover = false
            _this.coverWarn = info.response
          }
        },

        Error(up: any, err: any) {
          _this.allowCover = false
          _this.uploadError(err)
        }
      }
    })
    uploader.init()
  }

  handleSubmit(e: any) {
    e.preventDefault()
    const form: any = this.form
    const _this = this
    form.validateFieldsAndScroll((err: any, vals: any) => {
      if (!err) {
        if (!_this.viewSrc) {
          message.warning(_this.lang.noResource)
        } else if (!_this.resourceFileUploaded) {
          message.warning(_this.lang.resourceUpdating)
        } else {
          const data: any = {}
          if (_this.rid != '') {
            data.rid = _this.rid
          }
          data.title = vals.name
          vals.point ? (data.knowledge_point = vals.point) : false
          vals.desc ? (data.description = vals.desc) : false
          vals.label ? (data.key_word = vals.label) : false
          const phaseIds = []
          vals.primaryGroup.length > 0 ? phaseIds.push(10) : false
          vals.middleGroup.length > 0 ? phaseIds.push(20) : false
          data.phase_ids = phaseIds.join(',')
          data.subject_ids = vals.primaryGroup.concat(vals.middleGroup).join(',')
          data.file_url = _this.viewSrc
          // data.file_md5 = _this.md5
          data.file_size = _this.fileSize
          data.cover = _this.coverSrc
          if (_this.viewVideo || _this.viewScreenVideo) {
            data.file_type = _this.screen
          }
          if (_this.viewVideo || _this.viewScreenVideo) {
            data.file_type = _this.screen
          }
          _this.coverFileSize ? (data.cover_file_size = _this.coverFileSize) : false
          _this.submiting = true
          post('/api/UserRes/editPost', data)
            .then((res: any) => {
              if (res.s == 200) {
                message.success(res.data)
                _this.$router.push({
                  name: 'resourceList',
                  params: {}
                })
              }
              _this.submiting = false
            })
            .catch()
        }
      }
    })
  }

  // 删除无用资源
  async deleteResource(type: string, data: any) {
    if (
      (this.currentResource && type == 'resource') ||
      (this.upLoadedCover && type == 'cover')
    ) {
      await post('/api/UserRes/ResourceCloudDisk', data).then((res: any) => {})
      this.getCloudSpace()
    }
  }

  destroyViewer(name: string = 'resourceListUpload') {
    coverName = ''
    resourceName = ''
    if (this.resourceViewer != null && name == 'resourceListUpload') {
      if (this.resourceViewer.stop) {
        this.resourceViewer.stop()
      }
      this.resourceViewer = null
    }
  }
  // 设置资源删除参数
  setDeletePostData(type: string, destroy: boolean) {
    const data: any = {}
    if (this.rid) {
      data.rid = this.rid
      data.type = 2
    } else {
      data.type = 1
    }
    if (type == 'resource') {
      data.file = this.lastResourceUrl
      data.fileType = 1
    } else if (type == 'cover') {
      data.file = this.lastCoverUrl
      data.fileType = 2
    }
    if (destroy) {
      data.type = 3
      if (type == 'resource') {
        data.file = this.lastResourceUrl
      } else if (type == 'cover') {
        data.file = this.lastCoverUrl
      }
    }
    return data
  }

  mounted() {
    this.setConfig()
  }
  created() {
    this.doc = window.document
    this.lang = this.i18n.resource
    this.form = this.$form.createForm(this)
    if (this.$route.params.id) {
      this.rid = this.$route.params.id
      this.fetch()
    }
    this.getCloudSpace(true)
  }
  destroyed() {
    this.destroyViewer()
  }
  @Watch('$route')
  routechange(to: any, from: any) {
    this.destroyViewer(from.name)
  }
}
